import { createContext } from 'react';
var RowContext = /*#__PURE__*/createContext({});
export default RowContext;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/grid/RowContext.js
// module id = 432
// module chunks = 0